import React from 'react';
import { LargeHeading } from '@/components/Views/Heading';
import BalanceText from '@/components/BalanceText/BalanceText';

interface Props {
    heading?: string;
    infoItems?: any;
}

const InfoItem = ({ header, text, icon, index }) => {
    return (
        <div className='info-item-container relative '>
            <img src={icon.url} />
            <h3 className='my-0 text-lg md:text-xl font-semibold text-[#111827] text-left'>{header}</h3>
            <p className='text-base text-[#4B5563] font-light text-left'>{text}</p>
            <style jsx>
                {`
                    .info-item-container {
                    }
                `}
            </style>
        </div>
    );
};

const Hero = ({ heading, infoItems }: Props) => {
    return (
        <div className='hero-container bg-white' id='hero'>
            <div className='mx-auto default-max-w'>
                <div className='mx-auto text-center'>
                    <LargeHeading as='h1' className='lg:text-center'>
                        <BalanceText>{heading}</BalanceText>
                    </LargeHeading>
                </div>
            </div>

            <style jsx>{`
                #hero {
                    .info-items-container {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-gap: 28px 30px;

                        @media (max-width: 650px) {
                            grid-template-columns: 1fr;
                        }
                    }
                }

                #background-image {
                    background-image: url('/assets/graphics/explore-math-bg.png');
                    background-position: 100% 40px;
                    background-size: 75%;
                    @media (max-width: 1500px) {
                    }
                }
            `}</style>
        </div>
    );
};

export default Hero;
